import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
import { RootState } from "../../store";
import { EvaluatedRights } from "../../../interfaces/Rights";

const { REACT_APP_API_PATH } = process.env;

export const getRights = createAsyncThunk(
    "rights/getRights",
    async (period: string | undefined, thunkAPI) => {

        try {
            const url = period
                ? `${REACT_APP_API_PATH}/derechos?periodo=${period}`
                : `${REACT_APP_API_PATH}/derechos`;

            const response = await axiosInstance.get(url);

            const data = response.data;

            const { periods } = thunkAPI.getState() as RootState;

            const evaluatedPeriod = periods.periods?.find((p) => {
                const match = p.value.match(/\d{4}$/);
                return match && match[0] === String(period);
            });

            let processedRights = data.data;

            if (evaluatedPeriod?.estado === 2 && period) {
                processedRights = data.data.map((right: EvaluatedRights) => {
                    const updatedEvaluaciones = { ...right.evaluaciones };

                    updatedEvaluaciones[period] = {
                        suma_aritmetica: {
                            total: 0,
                            positivos: 0,
                            negativos: 0,
                            neutros: 0,
                            total_con_valor: -1, // <- sentinel for "En proceso"
                        },
                        evaluacion_trivalente: 2, // <- status for "En proceso"
                    };

                    return {
                        ...right,
                        evaluaciones: updatedEvaluaciones,
                    };
                });
            }

            return {
                rights: processedRights,
            };
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);